import { ReactNode } from 'react';
import { X } from 'lucide-react';
import { AnalyticsThemeProvider } from '../../theme/ThemeProvider';

interface AnalyticsModalProps {
  isOpen: boolean;
  title?: ReactNode;
  headerContent?: ReactNode;
  children: ReactNode;
  onClose: () => void;
  className?: string;
}

export function AnalyticsModal({
  isOpen,
  title,
  headerContent,
  children,
  onClose,
  className = '',
}: AnalyticsModalProps) {
  if (!isOpen) return null;

  return (
    <AnalyticsThemeProvider>
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
        onClick={onClose}
      >
        <div
          className={`relative flex max-h-[calc(100dvh-5rem)] w-full flex-col rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface)] text-[var(--anl-text)] shadow-xl ${className}`}
          onClick={e => e.stopPropagation()}
        >
          {(title || headerContent) && (
            <div className="flex shrink-0 items-center justify-between rounded-t-lg border-b border-[var(--anl-border)] bg-[var(--anl-surface)] p-3">
              {title ? (
                <h2 className="text-base font-semibold text-[var(--anl-text)] md:text-xl">{title}</h2>
              ) : (
                <div />
              )}
              <div className="flex items-center gap-2">
                {headerContent}
                <button
                  type="button"
                  onClick={onClose}
                  className="rounded-md p-1 text-[var(--anl-text-muted)] transition-colors hover:bg-[var(--anl-surface-elev)] hover:text-[var(--anl-text)]"
                  aria-label="Close"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>
            </div>
          )}
          {!title && !headerContent && (
            <button
              type="button"
              onClick={onClose}
              className="absolute right-3 top-3 rounded-md p-1 text-[var(--anl-text-muted)] transition-colors hover:bg-[var(--anl-surface-elev)] hover:text-[var(--anl-text)]"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
          )}
          <div className="min-h-0 flex-1 overflow-auto p-3">{children}</div>
        </div>
      </div>
    </AnalyticsThemeProvider>
  );
}
